// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:03:26

export default {
  "id": "crash-the-robot",
  "slug": "crash-the-robot",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/87f9ffc85db2452093d4f01a7d9982f9-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/87f9ffc85db2452093d4f01a7d9982f9/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Crash the Robot!",
      "description": "An addictive physics puzzle game, the goal of which is to crash the robot on each level in all sorts of ways or give him the opportunity to do so himself. Arrange items from your inventory and trigger a chain of events to reach the goal! Also use cannons and jumppads.\n\nThe game has over 50 levels +5 bonus levels!",
      "instructions": "Drag items from the inventory at the top of the screen onto the game scene and start the chain of events by clicking on the \"Start\" button at the bottom, middle of the screen.\n\nTo fire the cannon, turn it to the desired angle, simultaneously select the force of the shot and release it. The shot will be fired automatically if the number of shots is indicated on the cannon.\n\nControls:\nPC: mouse. 'P'/'Esc' - pause. 'R' - restart level.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "bomb",
        "crash",
        "logic",
        "physics",
        "robot"
      ]
    },
    "zh-CN": {
      "title": "摧毁机器人！",
      "description": "一款令人上瘾的物理益智游戏，目标是在每个关卡以各种方式让机器人坠毁，或者给他自己坠毁的机会。从你的库存中安排物品，引发一系列事件以达到目标！还可以使用加农炮和跳板。\n\n游戏包含超过50个关卡+5个奖励关卡！",
      "instructions": "将屏幕顶部的物品从背包拖到游戏场景中，然后点击屏幕底部中间的“开始”按钮，启动事件连锁。\n\n要发射加农炮，将其调整到所需角度，同时选择射击力度并释放。如果加农炮上指示了射击次数，射击将自动进行。\n\n控制方式：\nPC：鼠标。'P'/'Esc' - 暂停。'R' - 重新开始关卡。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "炸弹",
        "崩溃",
        "逻辑",
        "物理",
        "机器人"
      ]
    },
    "zh-TW": {
      "title": "搶搶機器人！",
      "description": "一個上癮的物理拼圖遊戲，目標是在每個關卡以各種方式讓機器人墜毀，或者讓他自己有機會這麼做。從你的倉庫中排列物品，觸發連鎖事件以達成目標！還可以使用大砲和彈跳板。\n\n遊戲內含有超過50個關卡 + 5個獎勵關卡！",
      "instructions": "將庫存中的物品從畫面頂部拖放到遊戲場景，然後點擊畫面底部中間的“開始”按鈕來啟動事件連鎖。\n\n要發射砲彈，將砲台轉到所需的角度，同時選擇射擊力度並釋放。如果砲台上指示了射擊次數，砲彈將自動發射。\n\n控制方式：\nPC：滑鼠。'P'/'Esc' - 暫停。'R' - 重啟關卡。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "炸彈",
        "撞毀",
        "邏輯",
        "物理",
        "機器人"
      ]
    },
    "zh-HK": {
      "title": "搗毀機械人！",
      "description": "一個上癮的物理迷謎遊戲，目標是在每個關卡中用各種方法撞毀機器人或讓他自行撞毀。安排你的庫存物品，觸發一系列事件以達成目標！還可使用砲台和彈跳板。\n\n遊戲共有多達50關 + 5關獎勵關！",
      "instructions": "將庫存中的物品從螢幕上方的位置拖動至遊戲場景，並按螢幕底部中央的「開始」按鈕啟動事件連鎖。\n\n要發射大炮，將其轉至欲射擊的角度，同時選擇射擊的力度並放開。若大炮上標示了射擊次數，射擊將自動發射。\n\n控制方式：\nPC：滑鼠。'P'/'Esc' - 暫停。'R' - 重啟關卡。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "炸彈",
        "撞毀",
        "邏輯",
        "物理",
        "機械人"
      ]
    },
    "ja": {
      "title": "ロボットをクラッシュせよ！",
      "description": "魅力的物理パズルゲームで、各レベルでロボットを様々な方法でクラッシュさせたり、自分でクラッシュさせる機会を作ることを目指します。インベントリからアイテムを配置し、目的までの連鎖反応を引き起こしましょう！また、砲門やジャンプパッドも使用してください。\n\nゲームには50レベル以上 +5ボーナスレベルがあります！",
      "instructions": "スクリーンの上端のインベントリからアイテムをドラッグしてゲームシーンに配置し、スクリーンの下部中央の「スタート」ボタンをクリックしてイベントの連鎖を開始します。\n\n大砲を発射するには、望む角度に回転させ、同時に発射の力を選択し、リリースします。大砲に発射回数が表示されている場合、自動的に発射されます。\n\nコントロール：\nPC：マウス。'P'/'Esc' - ペースト。'R' - レベルを再スタート。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "爆弾",
        "クラッシュ",
        "論理",
        "物理学",
        "ロボット"
      ]
    },
    "ko": {
      "title": "로봇을 부수세요!",
      "description": "불가능한 물리학 패자 게임, 목표는 각 레벨마다 로봇을 여러 가지 방식으로 충돌시키거나 그가 자신의 기회를 가지게 하다. 창고에서 아이템을 배치하고, 목표에 도달하기 위해 이벤트 연쇄를 유발하세요! 캐논과 점프 패드도 사용하세요.\n\n이 게임은 50개 이상의 레벨 +5 보너스 레벨을 가지고 있습니다!",
      "instructions": "화면 상단의 인벤토리에서 아이템을 드래그하여 게임 씬에 떨어뜨리고, 화면 중하단의 \"시작\" 버튼을 클릭하여 이벤트의 연쇄를 시작합니다.\n\n캐널을 발사하기 위해서는 원하는 각도로 돌려서, 발사력을 동시에 선택하고 떼어줍니다. 캐널에 발사 횟수가 표시되어 있으면 자동으로 발사됩니다.\n\n컨트롤:\nPC: 마우스. 'P'/'Esc' - 일시 중지. 'R' - 레벨 재시작.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "폭탄",
        "충돌",
        "논리",
        "물리학",
        "로봇"
      ]
    },
    "fr": {
      "title": "Crash le Robot !",
      "description": "Un jeu de puzzle de physique addictif, dont le but est de faire écraser le robot sur chaque niveau de toutes les manières possibles ou de lui donner l'occasion de le faire lui-même. Organisez les éléments de votre inventaire et déclenchez une série d'événements pour atteindre l'objectif ! Utilisez également des canons et des trampolines.\n\nLe jeu comporte plus de 50 niveaux + 5 niveaux bonus !",
      "instructions": "Déplacez des éléments de l'inventaire en haut de l'écran vers la scène de jeu et lancez la chaîne d'événements en cliquant sur le bouton \"Démarrer\" en bas et au centre de l'écran.\n\nPour tirer avec le canon, tournez-le à l'angle souhaité, sélectionnez simultanément la force du tir et relâchez. Le tir sera automatique si le nombre de coups est indiqué sur le canon.\n\nContrôles :\nPC : souris. 'P'/'Échap' - mettre en pause. 'R' - redémarrer le niveau.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "bombe",
        "crash",
        "logique",
        "physique",
        "robot"
      ]
    }
  }
};
